import { useState } from 'react';
import { useProducts } from '../lib/products-api';

export function ProductPicker({
  value: _value,
  valueName,
  valueCode,
  onChange,
  disabled,
}: {
  value: string;
  valueName?: string | null;
  valueCode?: string | null;
  onChange: (id: string, code: string, name: string) => void;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const productsQ = useProducts({
    pageSize: 50,
    ...(search.trim() && { search: search.trim() }),
    status: 'ACTIVE',
  });
  const display = valueName ? `${valueCode ? valueCode + ' — ' : ''}${valueName}` : '';
  return (
    <div className="relative">
      <button
        type="button"
        className="w-full rounded-md border border-slate-300 px-2 py-1 text-left text-xs"
        onClick={() => !disabled && setOpen((v) => !v)}
        disabled={disabled}
      >
        {display || '— scegli prodotto —'}
      </button>
      {open && (
        <div className="absolute z-10 mt-1 w-80 rounded-md border border-slate-300 bg-white p-2 shadow-lg">
          <input
            autoFocus
            type="text"
            className="mb-2 block w-full rounded border border-slate-300 px-2 py-1 text-xs"
            placeholder="Cerca prodotto..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <ul className="max-h-56 overflow-y-auto text-xs">
            {productsQ.isLoading && <li className="p-1 text-slate-400">Caricamento...</li>}
            {productsQ.data && productsQ.data.items.length === 0 && (
              <li className="p-1 text-slate-400">Nessun risultato</li>
            )}
            {productsQ.data?.items.map((p) => (
              <li
                key={p.id}
                className="cursor-pointer rounded p-1 hover:bg-slate-100"
                onClick={() => {
                  onChange(p.id, p.code, p.name);
                  setOpen(false);
                  setSearch('');
                }}
              >
                <span className="font-mono text-slate-400">{p.code}</span>
                <span className="ml-2 font-medium">{p.name}</span>
                <span className="ml-2 text-slate-500">{p.category}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
